export default "__VITE_ASSET__DwO0QvtW__"